import { FC } from 'react'
import { AccountLayout } from '../components/layout/AccountLayout'
import { ComingSoonPlaceholder } from '../components/layout/ComingSoonPlaceholder'

export const SettingsPage: FC = () => (
  <AccountLayout>
    <ComingSoonPlaceholder title="Configuración" />
  </AccountLayout>
)

export default SettingsPage
